import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@/views/user/LoginView.vue';
import RegisterView from '@/views/user/RegisterView.vue';
import HomeView from '@/views/HomeView.vue';
import MainDashboard from '@/views/dashboard/MainDashboard.vue';
import { useMenuStore } from '@/stores/menu'
import { security } from '@/stores/security'
import { BASE_URL } from '@/config';
const icon=BASE_URL+'/assets/images/fav.png'
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta:{onlyAuth:true}
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta:{checkHasMobileId:true,onlyAuth:true}
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: MainDashboard,
    meta: { requiresAuth: true },
    props: { view: 'dashboard' } 
  },
  {
    path: '/show-user-card/:id',
    name: 'show-user-card',
    component: MainDashboard,
    props: route => ({ view: 'show-user-card', id: route.params.id }),
  },
  {
    path: '/show-public',
    name: 'show-public',
    component: MainDashboard,
    props: { view: 'show-public' },
  },
  {
    path: '/add-product',
    name: 'add-product',
    component: MainDashboard,
    meta: { requiresAuth: true },
    props: { view: 'add-product' } 
  },
  {
    path: '/edit-product/:id',
    name: 'edit-product',
    component: MainDashboard,
    props: route => ({ view: 'edit-product', id: route.params.id }),
    meta: { requiresAuth: true }
  },
  {
    path: '/manage-product',
    name: 'manage-product',
    component: MainDashboard,
    meta: { requiresAuth: true },
    props: { view: 'manage-product' } 
  },
  {
    path: '/user-setting',
    name: 'user-setting',
    component: MainDashboard,
    meta: { requiresAuth: true },
    props: { view: 'user-setting' } 
  },
  {
    path: '/reaction-list',
    name: 'reaction-list',
    component: MainDashboard,
    meta: { requiresAuth: true },
    props: { view: 'reaction-list' } 
  },
  {
    path: '/show-product/:id',
    name: 'show-product',
    component: MainDashboard,
    props: route => ({ view: 'show-product', id: route.params.id }),
    meta: { requiresAuth: true }
  },
  {
    path: '/chat-list',
    name: 'chat-list',
    component: MainDashboard,
    meta: { requiresAuth: true },
    props: { view: 'chat-list' } 
  },
  {
    path: '/show-chat-product/:id',
    name: 'show-chat-product',
    component: MainDashboard,
    props: route => ({ view: 'show-chat-product', id: route.params.id }),
    meta: { requiresAuth: true }
  },
  {
    path: '/add-factor/:id',
    name: 'add-factor',
    component: MainDashboard,
    props: route => ({ view: 'add-factor', id: route.params.id }),
    meta: { requiresAuth: true }
  },
  {
    path: '/response-factor/:id/:factor/:mobile/:packId',
    name: 'response-factor',
    component: MainDashboard,
    props: route => ({ view: 'response-factor', id: route.params.id, factor: route.params.factor, mobile: route.params.mobile, packId: route.params.packId }),
    meta: { requiresAuth: true }
  },
  {
    path: '/manage-factor',
    name: 'manage-factor',
    component: MainDashboard,
    props: { view: 'manage-factor' },
    meta: { requiresAuth: true }
  },
  {
    path: '/show-chat-user/:id',
    name: 'show-chat-user',
    component: MainDashboard,
    props: route => ({ view: 'show-chat-user', id: route.params.id }),
    meta: { requiresAuth: true }
  },

]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach(async (to, from, next) => {
  if (to.name) {
    document.title = to.name;
  }
  const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
  link.href = icon;
  try {
    const meta = to.meta;
    if (meta.requiresAuth) {
      const res = await security('check_auth')
      if (!res) return next('/login');
    }
    if (meta.checkHasMobileId) {
      const res = await security('check_has_mobile')
      if (!res) return next('/login');
    }
    if (meta.onlyAuth) {
      const res = await security('check_auth')
      if (res) return next('/dashboard');
    }
    next();
  } catch (e) {
    console.error('Router Guard Error:', e);
    next('/');
  }
});
router.afterEach(() => {
  const menuStore = useMenuStore()
  menuStore.close()
})
export default router
